<template>
  <v-col cols="12">
    <p class="mt-3"><small >* campi obbligatori</small></p>
    <v-divider v-if="!loading"></v-divider>
    <v-progress-linear color="primary" class="w-100" indeterminate v-else height="2"></v-progress-linear>
  </v-col>
  <v-col cols="12" class="d-flex justify-space-between align-center">
    <div class="d-flex align-center">
      <v-btn prepend-icon="mdi-chevron-left" @click="$emit('back')" variant="elevated" color="primary" density="compact">Indietro</v-btn>
    </div>
    <div class="d-flex align-center">
      <v-btn v-if="$vuetify.display.mdAndUp" append-icon="mdi-content-save" @click="$emit('saveback')" size="small" class="mx-3" color="primary" :disabled="loading" :loading="loading">Salva e indietro</v-btn>
      <v-btn append-icon="mdi-content-save" type="submit" size="small" color="primary" :disabled="loading" :loading="loading">Salva</v-btn>
    </div>
  </v-col>

</template>

<script lang="ts">
export default {
  props : {
    loading : {
      type : Boolean,
      default: false
    }
  },
  emits : ["back", "saveback"],
  setup(props, ctx) {
    return {}
  }
}
</script>

<style scoped>

</style>
